import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { languages } from "../../constants/languages";
import EditAdminContainer from "../../containers/admins/EditAdminContainer";
import DeleteAdminContainer from "../../containers/admins/DeleteAdminContainer";

const styles = theme => ({
  root: {
    flexGrow: 1
  },
  heading: {
    fontWeight: 500
  }
});

function Admins(props) {
  const { classes } = props;
  return (
    <div className={classes.root}>
      <ExpansionPanel defaultExpanded={false}>
        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
          <Typography className={classes.heading}>
            {languages.admins.admins}
          </Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails style={{ paddingBottom: 0, paddingTop: 0 }}>
          <Typography variant="caption">
            {languages.admins.description}
          </Typography>
        </ExpansionPanelDetails>
        <ExpansionPanelDetails
          style={{ height: 147, paddingTop: 0, paddingBottom: 0 }}
        >
          <div style={{ height: 150, width: "100%", overflowY: "auto" }}>
            {props.admins.length > 0 && (
              <table>
                <tbody>
                  {props.admins
                    .sort((a, b) => {
                      if (a.name < b.name) {
                        return -1;
                      } else {
                        return 1;
                      }
                    })
                    .map((admin, i) => (
                      <tr key={admin.id} style={{ height: 25 }}>
                        <td>
                          <Typography>{i + 1 + "."}</Typography>
                        </td>
                        <td style={{ width: "90%" }}>
                          <Typography>{admin.name}</Typography>
                        </td>
                        <td>
                          <EditAdminContainer
                            tournament={props.tournament}
                            admin={admin}
                          />
                        </td>
                        <td>
                          <DeleteAdminContainer
                            tournament={props.tournament}
                            admin={admin}
                          />
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            )}
          </div>
        </ExpansionPanelDetails>
        {props.admins.length > 0 && (
          <ExpansionPanelDetails style={{ paddingBottom: 0, paddingTop: 0 }}>
            <Typography variant="caption">
              {languages.admins.description2}
            </Typography>
          </ExpansionPanelDetails>
        )}
        <ExpansionPanelDetails style={{ paddingBottom: 15, paddingTop: 10 }}>
          <EditAdminContainer tournament={props.tournament} />
        </ExpansionPanelDetails>
      </ExpansionPanel>
    </div>
  );
}

Admins.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(Admins);
